<template>
  <v-dialog v-model="dialogProxy" persistent>
    <v-card>
      <v-card-text>
        <v-col cols="12">
          <v-row dense>
            <!-- Datos del paro -->
            <v-col cols="12">
              <v-card outlined class="pa-4">
                <v-row no-gutters>
                  <!-- Datos de origen de paro -->
                  <v-col cols="4">
                    <div class="text-body-2">
                      <strong>Máquina:</strong> {{ paro.maquina }}
                    </div>
                    <div class="text-body-2">
                      <strong>Área:</strong> {{ paro.area }}
                    </div>
                    <div class="text-body-2">
                      <strong>Artículo:</strong> {{ paro.articulo }}
                    </div>
                    <div class="text-body-2">
                      <strong>Clave de orden de trabajo:</strong> {{ paro.claveTrabajoOrden }}
                    </div>
                  </v-col>

                  <!-- Datos de paro -->
                  <v-col cols="4" class="d-flex flex-column align-center justify-space-between mt-3 mt-md-0">
                    <div class="text-body-2">
                      <strong>Inicio:</strong> {{ formatFechaHora(paro.inicio) }}
                    </div>
                    <div class="text-body-2">
                      <strong>Fin:</strong> {{ formatFechaHora(paro.fin) }}
                    </div>
                    <div class="text-body-2">
                      <strong>Causa actual:</strong> {{ paro.paroTipo || '' }}
                    </div>
                    <div class="text-body-2">
                      <strong>Sub causa actual:</strong> {{ paro.subParoTipo || '' }}
                    </div>
                  </v-col>

                  <!-- Agregar segmentaciones -->
                  <v-col cols="4" class="d-flex flex-column align-end justify-space-between mt-3 mt-md-0">
                    <div class="text-right">
                      <div class="d-flex align-center justify-end mb-2">
                        <v-chip small color="primary" text-color="white" class="mr-2">
                          {{ segmentCount }} secciones
                        </v-chip>
                      </div>
                      <v-btn color="primary" small dark @click="agregarSegmento()">
                        <v-icon left small>mdi-plus</v-icon>
                        Agregar sección
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <!-- Lista de segmentaciones -->
          <v-row dense>
            <v-col v-for="item in segments" :key="item.index" cols="12" md="6">
              <v-card outlined class="mb-3">
                <v-card-title class="subtitle-2 font-weight-bold py-2">
                  Segmento {{ item.index }}
                  <v-spacer></v-spacer>
                  <v-chip small :color="erroresCampo(item.index).length > 0 ? 'error' : 'success'" text-color="white">
                    {{ erroresCampo(item.index).length > 0 ? 'Error' : 'Ok' }}
                  </v-chip>
                </v-card-title>

                <v-card-text class="pt-0">
                  <v-row dense>
                    <v-col cols="12">
                      <span class="caption">Inicio</span>
                    </v-col>

                    <!-- Fecha inicio -->
                    <v-col cols="12" sm="6">
                      <v-menu v-model="menus[item.index].inicioFecha" :close-on-content-click="false" offset-y min-width="auto">
                        <template #activator="{ on, attrs }">
                          <v-text-field v-bind="attrs" v-on="on" dense outlined readonly label="Fecha inicio"
                            :value="item.fechaInicio || null" />
                        </template>
                        <v-card>
                          <v-date-picker v-model="item.fechaInicio" :min="minFecha" :max="maxFecha"
                            @input="onFechaInicioChange(item)" class="mx-calendar" />
                          <v-card-actions class="justify-end">
                            <v-btn text color="primary" @click="cerrarFechaInicio(item)">
                              OK
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </v-col>

                    <!-- Hora inicio -->
                    <v-col cols="12" sm="6">
                      <v-menu v-model="menus[item.index].inicioHora" :close-on-content-click="false" offset-y
                        min-width="auto" v-if="item.fechaInicio != null">
                        <template #activator="{ on, attrs }">
                          <v-text-field v-bind="attrs" v-on="on" dense outlined readonly label="Hora inicio"
                            :value="item.horaInicio || null" />
                        </template>

                        <v-card>
                          <v-time-picker v-model="item.horaInicio" format="24hr" ampm-in-title
                            :allowed-hours="h => allowedHours(h, item, 'inicio')" use-seconds
                            :allowed-minutes="m => allowedMinutes(m, item, 'inicio')"
                            :allowed-seconds="s => allowedSeconds(s, item, 'inicio')"
                            @input="onHoraInicioChange(item)" />

                          <v-card-actions>
                            <v-btn text color="primary" @click="cerrarHoraInicio(item)" class="ml-auto">
                              OK
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </v-col>

                    <v-col cols="12">
                      <span class="caption">Fin</span>
                    </v-col>

                    <!-- Fecha Fin -->
                    <v-col cols="12" sm="6">
                      <v-menu v-model="menus[item.index].finFecha" :close-on-content-click="false" offset-y min-width="auto">
                        <template #activator="{ on, attrs }">
                          <v-text-field v-bind="attrs" v-on="on" dense outlined readonly label="Fecha fin"
                            :value="item.fechaFin || null" />
                        </template>
                        <v-card>
                          <v-date-picker v-model="item.fechaFin" :min="minFecha" :max="maxFecha"
                            @input="onFechaFinChange(item)" class="mx-calendar" />
                          <v-card-actions class="justify-end">
                            <v-btn text color="primary" @click="cerrarFechaInicio(item)">
                              OK
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </v-col>

                    <!-- Hora fin -->
                    <v-col cols="12" sm="6">
                      <v-menu v-model="menus[item.index].finHora" :close-on-content-click="false" offset-y
                        min-width="auto" v-if="item.fechaFin != null">
                        <template #activator="{ on, attrs }">
                          <v-text-field v-bind="attrs" v-on="on" dense outlined readonly label="Hora fin"
                            :value="item.horaFin || null" :error-messages="erroresCampo(item.index, 'horaFin')" />
                        </template>

                        <v-card width="auto">
                          <v-time-picker v-model="item.horaFin" format="24hr" ampm-in-title
                            :allowed-hours="h => allowedHours(h, item, 'fin')" use-seconds
                            :allowed-minutes="m => allowedMinutes(m, item, 'fin')"
                            :allowed-seconds="s => allowedSeconds(s, item, 'fin')" @input="onHoraFinChange(item)" />
                          <v-card-actions>
                            <v-btn text color="primary" @click="cerrarHoraFin(item)" class="ml-auto">
                              OK
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-menu>
                    </v-col>

                    <!-- Paro Tipo -->
                    <v-col cols="12" sm="6">
                      <v-autocomplete v-model="item.idParoTipo" :items="parosTipos" item-text="nombre"
                        item-value="idParoTipo" dense hide-details="auto" clearable label="Causa" outlined required
                        @click="cambioParoTipo(item.index)" />
                    </v-col>

                    <!-- SubParo Tipo -->
                    <v-col cols="12" sm="6">
                      <v-autocomplete v-model="item.idSubParoTipo" :items="subParosTiposFiltrados(item)"
                        item-text="nombreSubParoTipo" item-value="idSubParoTipo" dense hide-details clearable outlined
                        label="Subtipo" />
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-actions class="py-1">
                  <v-spacer></v-spacer>
                  <v-btn small text color="red" @click="eliminarSegmento(item)">
                    <v-icon left small>mdi-delete</v-icon>
                    Eliminar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <!-- Lista de errores -->
        <v-col cols="12" v-if="erroresPorSegmento.length">
          <v-card outlined>
            <v-card-title class="subtitle-2 red--text text--darken-2">
              Errores en la segmentación
            </v-card-title>

            <v-card-text>
              <v-list dense>
                <v-list-item v-for="grupo in erroresPorSegmento" :key="grupo.segmento">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      Segmento {{ grupo.segmento === '-' ? 'General' : grupo.segmento }}
                    </v-list-item-title>

                    <v-list-item-subtitle>
                      <ul class="ma-0 pl-4">
                        <li v-for="(err, i) in grupo.errores" :key="i">
                          <strong v-if="err.campo !== 'general'">
                            {{ err.campo }}:
                          </strong>
                          {{ err.mensaje }}
                        </li>
                      </ul>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" text @click="close" :loading="loading">Cancelar</v-btn>
        <v-btn color="error" text :disabled="erroresPorSegmento.length > 0" @click="save" :loading="loading">
          Guardar segmentación
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    paro: {
      type: Object,
      default: {
        idParo: null,
        inicio: null,
        fin: null,
        duracionSeg: null,
        idsParos: [],
        idParoTipo: null,
        paroTipo: null,
        idSubParoTipo: null,
        subParoTipo: null,
        idArea: null,
        area: null,
        idMaquinaIns: null,
        maquina: null,
        idTrabajoOrden: null,
        claveTrabajoOrden: null,
        idTrabajoOrdenDetalle: null,
        articulo: null,
        idOperacionReal: null,
        idOperador: null,
        idEquipo: null
      },
    },
    reglasValidacion: {
      type: Object,
      default: {
        totalFragmentosExacto: false,
      },
    },
    parosTipos: {
      type: Array,
      default: () => []
    },
    subParosTipos: {
      type: Array,
      default: () => []
    },
  },

  data() {
    return {
      segments: [],

      menus: {},
    };
  },

  computed: {
    dialogProxy: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    segmentCount() {
      return this.segments.length;
    },
    minFecha() {
      return this.getFechaHoraParts(this.paro.inicio).fecha;
    },
    maxFecha() {
      return this.getFechaHoraParts(this.paro.fin).fecha;
    },
    minHora() {
      return this.getFechaHoraParts(this.paro.inicio).hora || "00:00";
    },
    maxHora() {
      return this.getFechaHoraParts(this.paro.fin).hora || "23:59";
    },
    sumaSegmentosMin() {
      return this.segments.reduce(
        (acc, s) => acc + (Number(s.duracionMin) || 0),
        0
      );
    },
    sumaSegmentosTexto() {
      return this.formatMinutes(this.sumaSegmentosMin);
    },
    sumaActivosMin() {
      return this.segments
        .filter((s) => s.error)
        .reduce((acc, s) => acc + (Number(s.duracionMin) || 0), 0);
    },
    sumaActivosTexto() {
      return this.formatMinutes(this.sumaActivosMin);
    },
    errorMensaje() {
      if (!this.paro.totalMinutes) return "";

      // 🔹 Solo validar igualdad si la regla lo pide
      if (
        this.reglasValidacion &&
        this.reglasValidacion.totalFragmentosExacto &&
        this.sumaSegmentosMin !== this.paro.totalMinutes
      ) {
        return `La suma de segmentos (${this.sumaSegmentosTexto}) debe ser igual a la duración original (${this.paro.duracionTexto}).`;
      }
      const segmentosSinCausa = this.segments.filter(
        (s) => s.condicion !== false && !s.idParoTipo
      ).length;

      if (segmentosSinCausa > 0) {
        return "Todos los segmentos activos deben tener una causa de paro.";
      }

      const activos = this.segments.filter((s) => s.error).length;
      if (activos === 0) {
        return "Debe quedar al menos un segmento activo.";
      }

      return "";
    },
    listaErrores() {
      const errores = [];

      this.segments.forEach((seg) => {
        const segmento = seg.index;

        this.validarHoraInicio(seg).forEach(m =>
          errores.push({ segmento, campo: "horaInicio", mensaje: m })
        );

        this.validarHoraFin(seg).forEach(m =>
          errores.push({ segmento, campo: "horaFin", mensaje: m })
        );
      });

      if (this.errorMensaje) {
        errores.push({ segmento: "-", campo: "general", mensaje: this.errorMensaje });
      }

      return errores;
    },

    erroresPorSegmento() {
      const map = {};

      this.listaErrores.forEach(e => {
        const key = e.segmento;
        if (!map[key]) map[key] = [];
        map[key].push(e);
      });

      // lo convertimos a arreglo para usar v-for
      return Object.entries(map).map(([segmento, errores]) => ({
        segmento,
        errores,
      }));
    },
  },

  methods: {
    formatFechaHora(value) {
      if (!value) return '-';
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return value; // por si ya viene formateado

      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      const hh = String(d.getHours()).padStart(2, '0');
      const mi = String(d.getMinutes()).padStart(2, '0');
      const seg = String(d.getSeconds()).padStart(2, '0');

      return `${dd}/${mm}/${yyyy} ${hh}:${mi}:${seg}`;
    },

    formatDuracion(segundos) {
      if (segundos == null) return '-';
      const total = Number(segundos) || 0;
      const h = Math.floor(total / 3600);
      const m = Math.floor((total % 3600) / 60);
      return `${h}h ${m.toString().padStart(2, '0')}m`;
    },
    // ---------- inicialización ----------
    parseDateTimeString(str) {
      if (!str) return null;

      const s = String(str);
      let datePart = null;
      let timePart = null;

      if (s.includes("T")) {
        // ISO: 2025-12-01T08:15:37
        [datePart, timePart] = s.split("T");
      } else if (s.includes(" ")) {
        // 2025-12-01 08:15
        [datePart, timePart] = s.split(" ");
      } else {
        return null;
      }

      const [y, mo, d] = (datePart || "").split("-").map(v => parseInt(v, 10));
      if (Number.isNaN(y) || Number.isNaN(mo) || Number.isNaN(d)) return null;

      // limpiar segundos / Z si llegan
      const cleanTime = (timePart || "").replace("Z", "");
      const [h, mi, sec] = cleanTime.split(":").map(v => parseInt(v, 10) || 0);

      return new Date(y, mo - 1, d, h, mi, sec || 0, 0);
    },

    initParo() {
      const inicio = this.parseDateTimeString(this.paro.inicio);
      const fin = this.parseDateTimeString(this.paro.fin);

      if (!inicio || !fin) {
        this.paro.totalMinutes = 0;
        this.paro.duracionTexto = "";
        return;
      }

      const diffMs = fin.getTime() - inicio.getTime();
      const totalMin = Math.round(diffMs / 60000);

      this.paro.totalMinutes = totalMin > 0 ? totalMin : 0;
      this.paro.duracionTexto = this.formatMinutes(this.paro.totalMinutes);
      this.paro.inicioTexto = this.formatDateTime(inicio);
      this.paro.finTexto = this.formatDateTime(fin);
      this.paro.inicioHora = this.toHora(inicio);
      this.paro.finHora = this.toHora(fin);
    },

    agregarSegmento() {
      // siguiente índice
      const nextIndex = this.segments.length
        ? Math.max(...this.segments.map(s => s.index || 0)) + 1
        : 1;

      // valores base (pueden venir del rango del paro)
      const fechaBase = this.minFecha || null;
      const horaBase = this.minHora || null;

      const nuevo = {
        index: nextIndex,
        fechaInicio: null,
        horaInicio: null,
        fechaFin: null,
        horaFin: null,
        inicioTexto: "",
        finTexto: "",
        duracionMin: 0,
        idParoTipo: null,
        idSubParoTipo: null,
        error: true,
      };

      this.buildDateTimeStrings(nuevo);
      this.segments.push(nuevo);

      // inicializar menús para este segmento
      this.$set(this.menus, nextIndex, {
        inicioFecha: false,
        inicioHora: false,
        finFecha: false,
        finHora: false,
      });

      this.actualizarDuraciones();
    },
    cambioParoTipo(idx) {
      this.segments[idx - 1].idSubParoTipo = null;
    },

    eliminarSegmento(item) {
      const idx = this.segments.indexOf(item);
      if (idx === -1) return;

      // eliminar segmento de la lista
      this.segments.splice(idx, 1);

      // reindexar índices y reconstruir menús
      const nuevoMenus = {};
      this.segments.forEach((seg, i) => {
        const nuevoIndex = i + 1;
        const viejoIndex = seg.index;

        seg.index = nuevoIndex;

        if (this.menus[viejoIndex]) {
          nuevoMenus[nuevoIndex] = this.menus[viejoIndex];
        } else {
          nuevoMenus[nuevoIndex] = {
            inicioFecha: false,
            inicioHora: false,
            finFecha: false,
            finHora: false,
          };
        }
      });

      this.menus = nuevoMenus;
      this.actualizarDuraciones();
    },

    // ---------- helpers de tiempo ----------
    formatMinutes(min) {
      if (!min && min !== 0) return "";
      const h = Math.floor(min / 60);
      const m = min % 60;
      return `${h}:${m.toString().padStart(2, "0")} h`;
    },

    toHora(date) {
      const h = date.getHours().toString().padStart(2, "0");
      const m = date.getMinutes().toString().padStart(2, "0");
      return `${h}:${m}`;
    },

    formatDateTime(date) {
      const d = date.getDate().toString().padStart(2, "0");
      const mo = (date.getMonth() + 1).toString().padStart(2, "0");
      const y = date.getFullYear();
      const h = date.getHours().toString().padStart(2, "0");
      const m = date.getMinutes().toString().padStart(2, "0");
      return `${d}/${mo}/${y} ${h}:${m}`;
    },

    /*buildDateTimeStrings(seg) {
      if (seg.fechaInicio && seg.horaInicio) {
        seg.inicioTexto = `${seg.fechaInicio} ${seg.horaInicio}`;
      }
      if (seg.fechaFin && seg.horaFin) {
        seg.finTexto = `${seg.fechaFin} ${seg.horaFin}`;
      }
    },*/
    buildDateTimeStrings(seg) {
      if (seg.fechaInicio && seg.horaInicio) {
        seg.inicioTexto = `${seg.fechaInicio}T${seg.horaInicio}`;
      }
      if (seg.fechaFin && seg.horaFin) {
        seg.finTexto = `${seg.fechaFin}T${seg.horaFin}`;
      }
    },

    actualizarDuraciones() {
      this.segments.forEach((seg) => {
        const ini = this.parseDateTimeString(seg.inicioTexto);
        const fin = this.parseDateTimeString(seg.finTexto);
        if (!ini || !fin) {
          seg.duracionMin = 0;
          return;
        }
        let diffMs = fin.getTime() - ini.getTime();
        if (diffMs < 0) diffMs = 0;
        seg.duracionMin = Math.round(diffMs / 60000);
      });
    },

    // ---------- allowed hours/minutes ----------
    allowedHours(h, item, tipo) {
      const hh = Number(h);
      const fecha = tipo === "inicio"
        ? item.fechaInicio
        : item.fechaFin || item.fechaInicio;
      if (!fecha) return true;

      const [minH] = this.minHora.split(":").map(v => parseInt(v, 10));
      const [maxH] = this.maxHora.split(":").map(v => parseInt(v, 10));
      const minF = this.minFecha;
      const maxF = this.maxFecha;

      // 1 solo día: solo horas entre inicio y fin del paro
      if (minF === maxF) {
        return hh >= minH && hh <= maxH;
      }

      // primer día: desde hora de inicio del paro
      if (fecha === minF) return hh >= minH;
      // último día: hasta hora de fin del paro
      if (fecha === maxF) return hh <= maxH;

      // días intermedios: cualquier hora
      return true;
    },

    allowedMinutes(m, item, tipo) {
      const fecha = tipo === "inicio"
        ? item.fechaInicio
        : (item.fechaFin || item.fechaInicio);

      if (!fecha) return true;

      // Hora actual del ítem (inicio o fin)
      const rawHora = tipo === "inicio"
        ? item.horaInicio
        : (item.horaFin || item.horaInicio);

      // Si aún no hay hora seleccionada (primer render),
      // usamos como fallback la hora del paro (inicio o fin)
      let hh;
      if (rawHora) {
        hh = parseInt(String(rawHora).split(":")[0], 10);
      } else {
        const baseHora = (tipo === "inicio" ? this.minHora : this.maxHora) || "00:00";
        hh = parseInt(baseHora.split(":")[0], 10);
      }

      const mm = Number(m);

      const [minH, minM] = this.minHora.split(":").map(v => parseInt(v, 10));
      const [maxH, maxM] = this.maxHora.split(":").map(v => parseInt(v, 10));
      const minF = this.minFecha;
      const maxF = this.maxFecha;

      // 🔹 Caso: el paro empieza y termina el MISMO día
      if (minF === maxF) {
        if (fecha !== minF) return true; // seguridad

        // por si alguna hora fuera de rango se cuela
        if (hh < minH || hh > maxH) return false;

        if (hh === minH && mm < minM) return false; // antes del inicio
        if (hh === maxH && mm > maxM) return false; // después del fin

        return true;
      }

      // 🔹 Paro en varios días
      // Primer día: limitar solo si es la hora mínima
      if (fecha === minF && hh === minH && mm < minM) return false;

      // Último día: limitar solo si es la hora máxima
      if (fecha === maxF && hh === maxH && mm > maxM) return false;

      // Días intermedios: cualquier minuto
      return true;
    },
    allowedSeconds(s, item, tipo) {
      const fecha = tipo === "inicio"
        ? item.fechaInicio
        : (item.fechaFin || item.fechaInicio);
      if (!fecha) return true;

      const sec = Number(s);

      // Limites reales con segundos, usando el paro original
      const minDt = this.parseDateTimeString(this.paro.inicio);
      const maxDt = this.parseDateTimeString(this.paro.fin);

      // Hora/minuto actuales del ítem (inicio o fin)
      const rawHora = tipo === "inicio"
        ? item.horaInicio
        : (item.horaFin || item.horaInicio);

      let hh, mm;
      if (rawHora) {
        const parts = String(rawHora).split(":");
        hh = parseInt(parts[0], 10);
        mm = parseInt(parts[1], 10);
      } else {
        // mismo fallback que en allowedMinutes
        const baseHora = (tipo === "inicio" ? this.minHora : this.maxHora) || "00:00";
        const [hBase, mBase] = baseHora.split(":").map(v => parseInt(v, 10));
        hh = hBase;
        mm = mBase;
      }

      const minF = this.minFecha;
      const maxF = this.maxFecha;

      const curSec = hh * 3600 + mm * 60 + sec;
      const minSec = minDt.getHours() * 3600 + minDt.getMinutes() * 60 + minDt.getSeconds();
      const maxSec = maxDt.getHours() * 3600 + maxDt.getMinutes() * 60 + maxDt.getSeconds();

      // 🔹 Mismo día: segundos entre inicio y fin
      if (minF === maxF) {
        if (fecha !== minF) return true;
        return curSec >= minSec && curSec <= maxSec;
      }

      // 🔹 Varios días: limitar solo en primer y último día
      if (fecha === minF) return curSec >= minSec;
      if (fecha === maxF) return curSec <= maxSec;

      // Días intermedios: cualquier segundo
      return true;
    },


    subParosTiposFiltrados(item) {
      if (!item || item.idParoTipo == null) return []

      if (
        item.idSubParoTipo &&
        !this.subParosTipos.some(
          tp => tp.idParoTipo === item.idParoTipo && tp.idSubParoTipo === item.idSubParoTipo
        )
      ) {
        item.idSubParoTipo = null
      }

      return this.subParosTipos.filter(tp => tp.idParoTipo === item.idParoTipo)
    },

    // ---------- eventos date/time ----------
    onFechaInicioChange(item) {
      this.buildDateTimeStrings(item);
      this.actualizarDuraciones();
    },

    onHoraInicioChange(item) {
      // se ejecuta en cada cambio (am/pm, hora, minuto)
      this.buildDateTimeStrings(item);
      this.actualizarDuraciones();
    },

    cerrarFechaInicio(item) {
      if (this.menus[item.index]) {
        this.menus[item.index].inicioFecha = false;
      }
    },
    cerrarHoraInicio(item) {
      if (this.menus[item.index]) {
        this.menus[item.index].inicioHora = false;
      }
    },

    onFechaFinChange(item) {
      this.buildDateTimeStrings(item);
      this.actualizarDuraciones();
    },

    onHoraFinChange(item) {
      // Se actualiza en cada cambio de hora/minuto
      this.buildDateTimeStrings(item);
      this.actualizarDuraciones();
      // NO cerramos el menú aquí
    },

    cerrarHoraFin(item) {
      if (this.menus[item.index]) {
        this.menus[item.index].finHora = false; // se cierra solo al dar OK
      }
    },

    // ---------- acciones ----------
    close() {
      this.dialogProxy = false;
    },

    save() {
      const segmentosLimpios = this.segments.map(s => ({
        idsParos: this.paro.idsParos,
        index: s.index,
        inicio: s.inicioTexto,
        fin: s.finTexto,
        idParoTipo: s.idParoTipo,
        idSubParoTipo: s.idSubParoTipo,
        condicion: s.condicion,
        duracionSeg: s.duracionSeg,
      }));

      this.$emit("guardar-segmentos", segmentosLimpios);
    },

    getFechaHoraParts(value) {
      if (!value) return { fecha: null, hora: null };

      const str = String(value);
      let datePart = null;
      let timePart = null;

      if (str.includes("T")) {
        // ISO: 2025-12-01T08:15:37
        [datePart, timePart] = str.split("T");
      } else if (str.includes(" ")) {
        // 2025-12-01 08:15
        [datePart, timePart] = str.split(" ");
      } else {
        datePart = str;
      }

      if (timePart) {
        // nos quedamos con HH:mm
        timePart = timePart.slice(0, 5);
      }

      return { fecha: datePart, hora: timePart };
    },
    validarHoraInicio(seg) {
      const errores = [];

      if (!seg.fechaInicio) errores.push("La fecha de inicio es obligatoria.");
      if (!seg.horaInicio) errores.push("La hora de inicio es obligatoria.");

      const ini = this.parseDateTimeString(seg.inicioTexto);
      const paroIni = this.parseDateTimeString(this.paro.inicio);
      const paroFin = this.parseDateTimeString(this.paro.fin);

      if (ini && paroIni && paroFin) {
        if (ini < paroIni || ini > paroFin) {
          errores.push("El inicio del segmento debe estar dentro del rango del paro.");
        }
      }

      return errores;
    },

    validarHoraFin(seg) {
      const errores = [];

      if (!seg.fechaFin) errores.push("La fecha de fin es obligatoria.");
      if (!seg.horaFin) errores.push("La hora de fin es obligatoria.");

      const ini = this.parseDateTimeString(seg.inicioTexto);
      const fin = this.parseDateTimeString(seg.finTexto);
      const paroIni = this.parseDateTimeString(this.paro.inicio);
      const paroFin = this.parseDateTimeString(this.paro.fin);

      if (fin && ini && fin <= ini) {
        errores.push("La fecha/hora fin debe ser mayor que la fecha/hora inicio.");
      }

      if (fin && paroIni && paroFin) {
        if (fin < paroIni || fin > paroFin) {
          errores.push("El fin del segmento debe estar dentro del rango del paro.");
        }
      }

      return errores;
    },

    erroresCampo(segmentoIndex, campo) {
      if (!campo) return this.listaErrores.filter(e => e.segmento === segmentoIndex)
      return this.listaErrores
        .filter(e => e.segmento === segmentoIndex && e.campo === campo)
        .map(e => e.mensaje);
    },
  },

  created() {
    this.segments = [];
    this.initParo();
  },
};
</script>

<style>
.mx-calendar {
  --mx-border: rgba(0, 0, 0, .10);
  --mx-gray: rgba(0, 0, 0, .60);
  --mx-gray-weak: rgba(0, 0, 0, .45);
  --mx-hover: rgba(0, 0, 0, .06);
  --mx-selected: rgba(33, 150, 243, .12);
  height: fit-content;
}

/* Header */
.mx-calendar .v-date-picker-header {
  border-bottom: 1px solid var(--mx-border);
  padding: 6px 8px;
}

.mx-calendar .v-date-picker-header__value {
  color: #000;
  font-weight: bold;
}

.mx-calendar .v-date-picker-header .v-btn--icon {
  color: var(--mx-gray);
}

/* Asegura que la tabla no limite el ancho */
.mx-calendar .v-date-picker-table,
.mx-calendar .v-date-picker-table table {
  width: auto !important;
}

/* Evita paddings que “roben” ancho */
.mx-calendar .v-date-picker-table {
  padding: 0 !important;
}

/* Encabezado de días: lu, ma, mi... en gris */
.mx-calendar .v-date-picker-table .v-date-picker-table--weekday th {
  color: var(--mx-gray-weak);
  font-weight: 600;
  font-size: 12px;
  text-transform: none;
}

/* Celdas de días: texto negro, pills rectangulares */
.mx-calendar .v-date-picker-table {
  padding: 0px 0px 0px;
}

.mx-calendar .v-date-picker-table .v-btn {
  min-width: 36px;
  height: 36px;
  border-radius: 100px;
  color: #000 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.mx-calendar .v-date-picker-table .v-btn:hover {
  background: var(--mx-hover) !important;
}

.mx-calendar .v-date-picker-table .v-btn,
.mx-calendar .v-date-picker-table .v-btn.v-btn--has-bg {
  background: transparent !important;
}

/* Tamaño del número del día dentro del date-picker */
.mx-calendar .v-date-picker-table .v-btn .v-btn__content {
  font-size: 12px;
  font-weight: 900;
}

.mx-calendar .v-date-picker-table .v-btn::before {
  opacity: 0 !important;
}

.mx-calendar .v-date-picker-table .v-btn {
  height: 32px;
  min-width: 32px;
  margin: 2px 3px;
  padding: 0;
  border-radius: 8px;
  box-shadow: none !important;
  color: #000 !important;
}

.mx-calendar .v-date-picker-table table,
.mx-calendar .v-date-picker-table tbody tr>td {
  background: transparent !important;
}

.mx-calendar .v-date-picker-table .v-btn.v-btn--active {
  background: rgba(33, 150, 243, .12) !important;
  box-shadow: inset 0 0 0 1px rgba(33, 150, 243, .35) !important;
  color: #000 !important;
}

.mx-calendar .v-date-picker-table .v-btn.today:not(.v-btn--active) {
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .35) !important;
}

.mx-calendar .v-date-picker-table .v-date-picker-table--date .v-btn.v-date-picker-table__current--disabled {
  color: rgba(0, 0, 0, .35) !important;
}

.mx-calendar .v-ripple__container {
  display: none;
}
</style>